import type { IDismantle } from "@framework/types";
import { cleanUpAsset } from "@framework/exchange";

export const dismantleCreateFilter = ({ item, price, rarityMultiplier, dismantleStrategy }: IDismantle) => ({
  item: cleanUpAsset(item) as any,
  price: cleanUpAsset(price) as any,
  rarityMultiplier,
  dismantleStrategy,
});

export const dismantleEditFilter = ({
  item,
  price,
  dismantleStatus,
  rarityMultiplier,
  dismantleStrategy,
}: IDismantle) => ({
  item: cleanUpAsset(item) as any,
  price: cleanUpAsset(price) as any,
  dismantleStatus,
  rarityMultiplier,
  dismantleStrategy,
});

export const prepareDismantleInitialValues = ({
  id,
  item,
  price,
  dismantleStatus,
  rarityMultiplier,
  dismantleStrategy,
}: Partial<IDismantle>) => {
  return {
    id,
    item,
    price,
    dismantleStatus,
    dismantleStrategy,
    rarityMultiplier,
  };
};
